import useMetaFiltersLoad from 'app/hooks/useMetaFiltersLoad';

const PrivateLayoutBackdrop = () => {
  useMetaFiltersLoad();

  return null;
};

export default PrivateLayoutBackdrop;
